import * as Yup from 'yup';

export interface IDStaffDorm {
  worker: { value: string; label: string } | null;
  hasEVisit: boolean;
}

export const initialValues: IDStaffDorm = { worker: null, hasEVisit: false };

export const validationSchema = Yup.object().shape({
  worker: Yup.mixed().required('validation.required'),
  hasEVisit: Yup.boolean().required('validation.required'),
});
